import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="pt-20 min-h-[80vh] flex items-center justify-center bg-neutral-warm">
      <div className="text-center px-4">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-accent mb-4">Errore 404</p>
        <h1 className="text-5xl md:text-6xl font-display font-bold text-primary mb-6">
          Pagina non trovata
        </h1>
        <p className="text-neutral-gray-600 text-lg max-w-md mx-auto mb-10 leading-relaxed">
          La pagina che cerchi non esiste o è stata spostata.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-accent text-white px-8 py-3.5 rounded-sm text-sm font-bold hover:bg-accent-dark transition-all"
        >
          <ArrowLeft className="w-4 h-4" />
          Torna alla Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
